module.exports = __webpack_public_path__ + "static/media/border-top.57638b2f.svg";